import { useCallback } from 'react';

/**
 * Custom hook to control visibility of the Sentry feedback button.
 * The button is identified by the `.sentry-feedback` class.
 */
export function useSentryFeedbackButton() {
  /**
   * Hides the Sentry feedback button if it exists in the DOM.
   */
  const hideFeedbackButton = useCallback(() => {
    const feedbackButton = document.querySelector<HTMLElement>('#sentry-feedback');
    if (feedbackButton) {
      feedbackButton.style.display = 'none';
    }
  }, []);

  /**
   * Restores (shows) the Sentry feedback button if it exists in the DOM.
   */
  const showFeedbackButton = useCallback(() => {
    const feedbackButton = document.querySelector<HTMLElement>('#sentry-feedback');
    if (feedbackButton) {
      feedbackButton.style.display = '';
    }
  }, []);

  return { hideFeedbackButton, showFeedbackButton };
}

export default useSentryFeedbackButton;
